import { render, staticRenderFns } from "./CellRendererProfile.vue?vue&type=template&id=05c8b17b"
import script from "./CellRendererProfile.vue?vue&type=script&lang=js"
export * from "./CellRendererProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports